import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Action } from '../constants/action-catalogue';
import { ProfileDataService } from '../services/profile-data.service';
import { ViewerService } from '../services/viewer.service';
import { isAdminPreview } from './admin-preview';
import { AnalyticsService } from '../services/analytics.service';
import { ANALYTICS_EVENTS } from '../analytics/events';

/** Deep-link guard for the Building alerts + Closures admin surfaces. */
export function buildingAlertManagementGuard(): CanActivateFn {
  return async (route) => {
    if (isAdminPreview(route)) return true;
    const viewer = inject(ViewerService);
    const profile = inject(ProfileDataService);
    const router = inject(Router);
    const analytics = inject(AnalyticsService);
    await viewer.ensureLoaded();
    if (profile.canDo(Action.BUILDING_ALERT_MANAGE)) return true;
    analytics.capture(ANALYTICS_EVENTS.CLOSURE_PERMISSION_BLOCKED, {
      surface:
        route.routeConfig?.path === 'alerts'
          ? 'alerts-route'
          : 'closures-route',
      required_action: Action.BUILDING_ALERT_MANAGE,
    });
    return router.createUrlTree(['/home-preview']);
  };
}
